import debounce from 'lodash/debounce';
import slice from 'lodash/slice';
import template from './presence-students.html';

class SummariesPresenceStudentsComponent {
  constructor(
    $log, moment,
    SummaryService,
    UtilService
  ) {
    'ngInject';
    this.$log = $log;
    this.moment = moment;
    this.SummaryService = SummaryService;
    this.UtilService = UtilService;

    this.dataTable = {};
    this.loadPageCallbackWithDebounce = {};
    this.filter = {
      dateFrom: this.moment().subtract(7, 'days').toDate(),
      dateTo: this.moment().toDate(),
      selectedGroup: 'ALL',
      selectedStudent: 'ALL'
    };
    this._groups = [];
    this._students = [];
    this._filteredStudents = [];
    this.summary = [];
    this.series = ['Obecni uczniowie'];
    this.allLabels = [];
    this.allData = [];
    this.displayData = [];
    this.displayLabels = [];
    this.currentChartType = 'day';
    this.currentWeek = 1;
    this.allWeeks = 0;

    this.chartOptions = {
      scales: {
        xAxes: [{
          maxBarThickness: 50
        }],
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: 'Liczba uczniów',
            fontFamily: '\'Roboto\', \'Arial\', sans-serif',
            fontSize: 14
          },
          ticks: {
            beginAtZero: true,
            maxTicksLimit: 8,
            userCallback(label) {
              if (Math.floor(label) === label) {
                return label;
              }
            },
            min: 0
          }
        }]
      }
    };
  }

  $onInit() {
    this.setFilter(this.filter);
  }

  $onChanges(changes) {
    if (changes.groups) {
      angular.copy(this.groups, this._groups);
    }

    if (changes.students) {
      angular.copy(this.students.data.students, this._students);
      angular.copy(this._students, this._filteredStudents);
    }
  }

  getLoadResultsCallback(loadPageCallback) {
    this.loadPageCallbackWithDebounce = debounce(loadPageCallback, 1000);
  }

  paginatorCallback(page = 1, pageSize = 0) {
    let offset = (page - 1) * pageSize;
    if (angular.isUndefined(offset)) {
      offset = 0;
    }

    const filterParams = this.getFilterParams();
    return this.SummaryService.getStudentsPrecence({
      ...filterParams,
      offset,
      limit: pageSize
    }).then(({summary, total, totalNumberStudents, totalStudentsPresenceTime}) => {
      this.summary = [{
        totalNumberStudents,
        totalStudentsPresenceTime
      }];
      return {
        results: summary,
        totalResultCount: total
      };
    });
  }

  submitFilterForm(filterForm, filterState) {
    if (!filterForm.$valid || this.isDateBefore(filterState.dateTo, filterState.dateFrom)) {
      return false;
    }

    this.setFilter(filterState);
    this.dataTableGoToFirstPage();
  }

  setFilter(filterState) {
    this.filterState = {...filterState};

    this.loadChartData(this.currentChartType);
  }

  dataTableGoToFirstPage() {
    this.dataTable.mdtPaginationHelper.getFirstPage();
  }

  getFilterParams() {
    const filterParams = {
      dateFrom: this.moment(this.filterState.dateFrom).format('YYYY-MM-DD'),
      dateTo: this.moment(this.filterState.dateTo).format('YYYY-MM-DD')
    };
    if (this.filterState.selectedGroup !== 'ALL') {
      filterParams.groupIds = this.filterState.selectedGroup;
    }

    if (this.filterState.selectedStudent !== 'ALL') {
      filterParams.studentIds = this.filterState.selectedStudent;
    }

    return filterParams;
  }

  filterGroupChange(groupId) {
    this.filterState.selectedStudent = 'ALL';
    this._filteredStudents = this._students.filter(student => {
      if (groupId === 'ALL') {
        return true;
      }

      return student.groupId === parseInt(groupId, 10);
    });
  }

  loadChartData(chartType = 'day') {
    const {dateFrom, dateTo, studentIds, groupIds} = this.getFilterParams();
    switch (chartType) {
      case 'day':
        this.loadDayChartData({
          dateFrom,
          dateTo,
          studentId: studentIds,
          groupIds
        });
        break;
      case 'month':
        this.loadMonthChartData({
          dateFrom,
          dateTo,
          studentId: studentIds,
          groupIds
        });
        break;
      default:
        break;
    }
  }

  loadDayChartData(params) {
    return this.SummaryService.getStudentPresenceToDayChart(params)
      .then(data => {
        this.currentWeek = 1;
        this.allWeeks = data.length / 7;
        this.allLabels = data.map(item => this.moment(item.date).format('DD.MM'));
        this.allData = data.map(item => item.studentsNumber);

        this.setDayChartData();
      })
      .catch(err => this.$log.error('1', err));
  }

  loadMonthChartData(params) {
    return this.SummaryService.getStudentPresenceToMonthChart(params)
      .then(data => {
        this.displayLabels = data.map(item => this.moment(item.date).format('MMMM'));
        this.displayData = [data.map(item => item.studentsNumber)];
      });
  }

  setDayChartData(week = 1) {
    const start = (week - 1) * 7;
    const end = week * 7;
    this.displayData = [slice(this.allData, start, end)];
    this.displayLabels = slice(this.allLabels, start, end);
  }

  nextWeek() {
    this.currentWeek += 1;
    this.setDayChartData(this.currentWeek);
  }

  previousWeek() {
    this.currentWeek -= 1;
    this.setDayChartData(this.currentWeek);
  }

  switchToDay() {
    this.currentChartType = 'day';
    this.loadChartData('day');
  }

  switchToMonth() {
    this.currentChartType = 'month';
    this.loadChartData('month');
  }

  isDateBefore(firstDate, secondDate) {
    if (!firstDate || !secondDate) {
      return false;
    }

    return this.moment(firstDate).isBefore(secondDate);
  }
}

export const PresenceStudents = {
  bindings: {
    groups: '<',
    students: '<'
  },
  template,
  controller: SummariesPresenceStudentsComponent
};
